import React, { useRef, useState, useEffect } from 'react';
import { func, array, number, bool, string, shape } from 'prop-types';
import { translate } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { fromEvent } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { Button } from '@snapask/common-components';

import AnswerList from '@blueberry/components/AnswerBlock';

import { getCurrentQuiz } from '@blueberry/redux/post';

import ExplanationBlock from './components/ExplanationBlock';

import styles from './AnswerBlock.scss';

const mapStateToProps = state => ({
  quiz: getCurrentQuiz(state),
});

function AnswerBlock({
  quiz: {
    ans_text: ansText,
    ans_images: ansImages,
    correct_ans: correctAns,
    explanation,
    explanation_image: explanationImage,
    answer,
    status,
    has_latex: hasLatex,
  },
  quiz,
  clickSubmit,
  isLatestQuiz,
  clickNext,
  t,
}) {
  const answerElement = useRef(null);
  const [answerIndex, setAnswerIndex] = useState(-1);
  const [buttonBottom, setButtonBottom] = useState(48);

  useEffect(() => {
    setAnswerIndex(-1);
    const scrollEvent = fromEvent(answerElement.current, 'scroll')
      .pipe(
        filter(() => !status),
        map(event => event.target),
        map(({ scrollTop }) => 48 - scrollTop)
      )
      .subscribe(bottom => setButtonBottom(bottom));

    return () => scrollEvent.unsubscribe();
  }, [quiz, status]);

  const clickAnswer = index => () => !status && setAnswerIndex(index);
  const afterRender = height => {
    const scrollTop = answerElement.current.scrollHeight - height;
    answerElement.current.scrollTop = scrollTop;
  };
  const onSubmit = () => {
    clickSubmit(answerIndex);
  };
  const onNext = () => {
    setAnswerIndex(-1);
    clickNext();
  };

  return (
    <div className={styles.root} ref={answerElement}>
      <AnswerList
        ansText={ansText}
        answerIndex={!!status ? answer : answerIndex}
        clickAnswer={clickAnswer}
        hasLatex={hasLatex}
        ansImages={ansImages}
        correctAns={correctAns}
        showAnswer={!!status}
      />
      {!status && <div className={styles.blank} />}
      {!status && (
        <span className={styles.button} style={{ bottom: `${buttonBottom}px` }}>
          <Button
            text={t('quizzes.submitCTA')}
            disabled={answerIndex === -1}
            onClick={onSubmit}
          />
        </span>
      )}
      {!!status && (
        <ExplanationBlock
          answer={answer}
          correctAns={correctAns}
          hasLatex={hasLatex}
          explanation={explanation}
          explanationImage={explanationImage}
          isLatestQuiz={isLatestQuiz}
          clickNext={onNext}
          afterRender={afterRender}
        />
      )}
    </div>
  );
}

AnswerBlock.propTypes = {
  clickNext: func.isRequired,
  clickSubmit: func.isRequired,
  isLatestQuiz: bool.isRequired,
  quiz: shape({
    correct_ans: number.isRequired,
    has_latex: bool.isRequired,
    ans_images: array,
    ans_text: array,
    answer: number,
    explanation: string,
    explanation_image: string,
    status: string,
  }).isRequired,
  t: func.isRequired,
};

AnswerBlock.defaultProps = {
  ansImages: [],
  ansText: [],
  explanation: '',
  explanationImage: '',
  status: '',
};

export default compose(
  connect(mapStateToProps),
  translate(['quizzes'])
)(AnswerBlock);



// WEBPACK FOOTER //
// ./app/containers/Post/components/PostContent/components/ContentBlock/components/QuizBlock/components/AnswerBlock/AnswerBlock.jsx